module.exports = __webpack_public_path__ + "static/quill4-d2850ae92a3613fc4f8ea8379c4db27d.png";